export class TestimonialViewModel {
  displayOrder: number;
  companyName: string;
  companyLogoUrl: string;
  author: string;
  description: string;
}